import moment from "moment-timezone";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";
import { StatusMessageCellRenderer } from "tap/components/AGGrid/cell-renderers/StatusMessageCellRenderer.jsx";

export const id = {
  field: "jobId",
  headerName: "Job",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "jobTasks",
  },
  minWidth: 100,
};

export const taskStatus = {
  field: "taskStatus",
  headerName: "Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "taskStatus",
    page: "jobTasks",
  },
  sortable: false,
  minWidth: 200,
};

export const statusMessage = {
  field: "statusMessage",
  headerName: "Message",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "statusMessage",
    page: "jobTasks",
  },
  cellRenderer: StatusMessageCellRenderer,
  minWidth: 250,
};

export const taskDetails = {
  field: "taskDetails",
  headerName: "Details",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "taskDetails",
    page: "jobTasks",
  },
  minWidth: 250,
};

export const createdAt = {
  field: "createdAt",
  headerName: "Created",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdAt",
    page: "jobTasks",
  },
  minWidth: 250,
};

export const modifiedAt = {
  field: "modifiedAt",
  headerName: "Modified",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "modifiedAt",
    page: "jobTasks",
  },
  minWidth: 250,
};

export const completedAt = {
  field: "completedAt",
  headerName: "Completed",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "completedAt",
    page: "jobTasks",
  },
  minWidth: 250,
};
